export default __webpack_public_path__ + "static/media/earlyAdopter.f974bdb3.svg";